import {Bag} from 'modules/reports/contexts/bag'
import {SearchContextProps} from 'modules/reports/hooks/search'
import React, {useContext} from 'react'
import {Props as ReportsTableColumnProps} from './Column/ReportsTableColumn'

export type ReportsTableContextProps = {
  tablePrefix: string
  tableColumns: ReportsTableColumnProps[]
  searchContext: SearchContextProps
  bag?: Bag
  tableOnClick: (item: any) => void
}

const ReportsTableContext = React.createContext<ReportsTableContextProps>(null as any)

export default ReportsTableContext

export function useReportsTableContext() {
  return useContext(ReportsTableContext)
}
